// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsParticleScreen_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6 5C6 5.55228 5.55228 6 5 6 4.44772 6 4 5.55228 4 5 4 4.44772 4.44772 4 5 4 5.55228 4 6 4.44772 6 5ZM12 6C12.5523 6 13 5.55228 13 5 13 4.44772 12.5523 4 12 4 11.4477 4 11 4.44772 11 5 11 5.55228 11.4477 6 12 6ZM20 7C20 8.10457 19.1046 9 18 9 16.8954 9 16 8.10457 16 7 16 5.89543 16.8954 5 18 5 19.1046 5 20 5.89543 20 7ZM14 13C15.1046 13 16 12.1046 16 11 16 9.89543 15.1046 9 14 9 12.8954 9 12 9.89543 12 11 12 12.1046 12.8954 13 14 13ZM18 20C19.1046 20 20 19.1046 20 18 20 16.8954 19.1046 16 18 16 16.8954 16 16 16.8954 16 18 16 19.1046 16.8954 20 18 20ZM9 9C9 10.1046 8.10457 11 7 11 5.89543 11 5 10.1046 5 9 5 7.89543 5.89543 7 7 7 8.10457 7 9 7.89543 9 9ZM19 15C19.5523 15 20 14.5523 20 14 20 13.4477 19.5523 13 19 13 18.4477 13 18 13.4477 18 14 18 14.5523 18.4477 15 19 15ZM13 17C13.5523 17 14 16.5523 14 16 14 15.4477 13.5523 15 13 15 12.4477 15 12 15.4477 12 16 12 16.5523 12.4477 17 13 17ZM12 19C12 19.5523 11.5523 20 11 20 10.4477 20 10 19.5523 10 19 10 18.4477 10.4477 18 11 18 11.5523 18 12 18.4477 12 19ZM6 20C7.10457 20 8 19.1046 8 18 8 16.8954 7.10457 16 6 16 4.89543 16 4 16.8954 4 18 4 19.1046 4.89543 20 6 20ZM9 14C9 14.5523 8.55229 15 8 15 7.44772 15 7 14.5523 7 14 7 13.4477 7.44772 13 8 13 8.55229 13 9 13.4477 9 14Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H24V24H0V0ZM2 2H22V22H2V2Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsParticleScreen is a generated icon component.
 */
let IconRmsParticleScreen = IconRmsParticleScreen_1 = class IconRmsParticleScreen extends IconBaseElement {
    render() {
        return html `${IconRmsParticleScreen_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsParticleScreen.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconRmsParticleScreen = IconRmsParticleScreen_1 = __decorate([
    customElement('zui-icon-rms-particle-screen')
], IconRmsParticleScreen);
export { IconRmsParticleScreen };
